<template>
  <div v-loading="loading">
    <div class="title">
      <div>
        <h3>{{ language("accountManagement.editAccount") }}</h3>
      </div>
      <el-button type="primary" @click="save">{{
        language("accountManagement.save")
      }}</el-button>
    </div>
    <el-divider></el-divider>
    <cc-form
      :config="formConfig"
      v-model="formData"
      ref="form"
      labelWidth="215px"
      :rules="rules"
      size="medium"
    ></cc-form>
    <div class="permission">
      <h3>{{ language("accountManagement.accessRights") }}</h3>
      <el-divider></el-divider>

      <el-form ref="form2" label-width="160px" label-position="left">
        <template v-for="(items, index) in accessRights">
          <el-form-item :label="items.name" prop="code" :key="index">
            <template  v-for="(itme, inde) in items.subMenuList">
              <div
                class="checkbox_wrap"
                v-if="!itme.hideList"
               :key="inde"
              >
                <div class="checkbox_title">
                  <h4>{{ itme.name }}</h4>
                </div>
                <div>
                  <template v-for="(checkbox, ind) in itme.subMenuList">
                    <el-checkbox
                      :key="ind"
                      :label="checkbox.name"
                      v-model="checkbox.check"
                      @change="change($event, index, inde, ind)"
                      :disabled="formData.disabled"
                    ></el-checkbox>
                  </template>
                </div>
              </div>
            </template>
         
          </el-form-item>
        </template>
      </el-form>
    </div>
  </div>
</template>
<script>
import shop from "./shop";
import deliverStatus from "./deliverStatus"
export default {
  props: {
    objData: Object,
  },
  data() {
    return {
      loading: true,
      formConfig: {
        props: [
          // {
          //   required: true,
          //   label: this.language("accountManagement.loginUser"),
          //   name: "account",
          //   type: "input",
          // },
          {
            // required: true,
            label: this.language("accountManagement.loginEmail"),
            name: "email",
            type: "input",
            disabled:this.objData.disabled
          },
          // {
          //   required: true,
          //   label: this.language("accountManagement.password"),
          //   name: "password",
          //   type: "input",
          // },
          // {
          //   required: true,
          //   label: this.language("accountManagement.confirmPassword"),
          //   name: "password2",
          //   type: "input",
          // },
          {
            // required: true,
            label: this.language("accountManagement.shop"),
            name: "shopIds",
            type: "input",
            type: "component",
            componentName: shop,
          },
          {
            // required: true,
            label: this.language("accountManagement.status"),
            name: "status",
            type: "radio",
            disabled:this.objData.disabled,

            options: [
              {
                val: 1,
                label: this.language("accountManagement.online"),
              },
              {
                val: 2,
                label: this.language("accountManagement.frozen"),
              },
              // {
              //   val: 3,
              //   label: "刪除",
              // },
            ],
          },
          {
            // required: true,
            label: this.language("accountManagement.expirydate"),
            name: "expirydateStr",
            type: "date",
            pickerOptionsDate: {
              shortcuts: [
                // {
                //   text: "今天",
                //   onClick(picker) {
                //     picker.$emit("pick", new Date());
                //   },
                // },
                {
                  text: this.language("accountManagement.week"),
                  onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
                    picker.$emit("pick", date);
                  },
                },
                {
                  text: this.language("accountManagement.month"),
                  onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
                    picker.$emit("pick", date);
                  },
                },
                {
                  text: this.language("accountManagement.year"),
                  onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() + 3600 * 1000 * 24 * 365);
                    picker.$emit("pick", date);
                  },
                },
                {
                  text: this.language("accountManagement.infinite"),
                  onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() + 3600 * 1000 * 24 * 99999);
                    picker.$emit("pick", date);
                  },
                },
              ],
            },
            // type: "datetimepicker",
            disabled:this.objData.disabled

          },
          {
            required: false,
            label: this.language("accountManagement.description"),
            name: "description",
            type: "input",
            disabled:this.objData.disabled

          },
          {
            // required: true,
            label: this.language("accountManagement.pdEmail"),
            name: "deliverStatus",
            type:"component",
            componentName:deliverStatus
            // type: "select",
            // options: [
            //   {
            //     value: 0,
            //     label: this.language("accountManagement.pick"),
            //   },
            //   {
            //     value: 1,
            //     label: this.language("accountManagement.delivered"),
            //   },
        
            // ],
          },
        ],
      },
      formData: {
        status: 1,
        // shopIds: [],
      },
      rules: {
        account: [
          {
            required: true,
            message: this.language("accountManagement.loginUserRules"),
            trigger: "blur",
            // validator: this.account,
            // trigger: "blur",
            // required: true,
          },
        ],
        email: [
          {
            required: true,
            message: this.language("accountManagement.loginEmailRules"),
            trigger: "blur",
          },
        ],
        expirydateStr: [
          {
            required: true,
            message: this.language("accountManagement.expirydateRules"),
            trigger: "blur",
          },
        ],
        shopIds: [
          {
            required: true,
            message: this.language("accountManagement.shopIdsRules"),
            trigger: "blur",
          },
        ],
        // deliverStatus:[
        //       {
        //     required: true,
        //     message: this.language("accountManagement.pdEmailRules"),
        //     trigger: "blur",
        //   },
        // ]
        // password: [
        //   {
        //     validator: this.validatePass,
        //     trigger: "change",
        //     required: true,
        //   },
        // ],
        // password2: [
        //   {
        //     validator: this.validatePass2,
        //     trigger: "change",
        //     required: true,
        //   },
        // ],
      },
      accessRights: [],
      checked: false,
      shopData: {},
    };
  },
  watch: {
    accessRights: {
      handler() {},
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // account(rule, value, callback) {
    //   if (value == undefined || value == "") {
    //     callback(new Error(this.language("accountManagement.loginUserRules")));
    //   } else {
    //     var r = /^[A-Za-z0-9@.]*$/;
    //     if (!r.test(value)) {
    //       callback(
    //         new Error(this.language("accountManagement.loginUserRulesTips"))
    //       );
    //     }
    //     callback();
    //   }
    // },
    validatePass2(rule, value, callback) {
      if (this.formData.password2 === "") {
        callback(new Error(this.language("accountManagement.validatePass")[0]));
      } else if (this.formData.password !== this.formData.password2) {
        callback(new Error(this.language("accountManagement.validatePass")[1]));
      } else {
        callback();
      }
    },
    validatePass(rule, value, callback) {
      if (this.formData.password === "") {
        callback(new Error(this.language("accountManagement.validatePass")[0]));
      } else if (this.formData.password) {
        var r = /^[A-Za-z0-9_]*$/;
        if (!r.test(this.formData.password)) {
          callback(new Error(this.language("accountManagement.format")));
        } else if (this.formData.password.length < 5) {
          callback(new Error(this.language("accountManagement.passMin")));
        }
        callback();
      } else if (
        this.formData.password2 &&
        this.formData.password !== this.formData.password2
      ) {
        callback(new Error(this.language("accountManagement.validatePass")[1]));
      } else {
        callback();
      }
    },
    getData() {
      this.ccRequest
        .do("admin/merchant/user/queryAccessRights", { pcode: "SIS-CMS" })
        .then((res) => {
          for (let i = 0; i < res.length; i++) {
            res[i].check = this.checkMenId(res[i].id);
            for (let t = 0; t < res[i].subMenuList.length; t++) {
               res[i].subMenuList[t].hideList = false

              res[i].subMenuList[t].check = this.checkMenId(
                res[i].subMenuList[t].id
              );

              for (
                let n = 0;
                n < res[i].subMenuList[t].subMenuList.length;
                n++
              ) {
                res[i].subMenuList[t].subMenuList[n].check = this.checkMenId(
                  res[i].subMenuList[t].subMenuList[n].id
                );
              }
              if( res[i].subMenuList[t].code=='SIS-Warehousing-Management'){
                console.log('shop',this.$shopData);
                if(!this.$shopData.isEscrow){
                  res[i].subMenuList[t].hideList = true
                }
                console.log('res[i].subMenuList[t]',res[i].subMenuList[t]);
              }
            }
          }
          console.log('res',res);
          this.accessRights = res;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.$message.error(err.response.data.message);
        });
    },
    checkMenId(id) {
      let type = false;
      if (this.objData && this.objData.id) {
        if (this.objData.menuIds && this.objData.menuIds.length > 0) {
          if (this.objData.menuIds.indexOf(id * 1) > -1) {
            type = true;
          }
        }
      } else {
        type = true;
      }

      return type;
    },
    change(e, index, inde, ind) {
      let name = this.accessRights[index].subMenuList[inde].subMenuList[ind]
        .name;
      if (e) {
        if (
          name == "Add" ||
          name == "Edit" ||
          name == "Delete" ||
          name == "Shop Status"
        ) {
          this.accessRights[index].subMenuList[
            inde
          ].subMenuList[0].check = true;
        }
      } else {
        if (name == "View") {
          console.log(this.accessRights[index].subMenuList[inde]);
          let subMenuList = this.accessRights[index].subMenuList[inde]
            .subMenuList;
          for (let i = 0; i < subMenuList.length; i++) {
            subMenuList[i].check = false;
          }
          this.accessRights[index].subMenuList[inde].subMenuList = subMenuList;
        }
      }
    },
    save() {
      this.$refs["form"]
        .validate()
        .then(() => {
          let formData = { ...this.formData };
          if (!formData.merchantNum) {
            formData.merchantNum = this.shopData.merchantNum;
          }
          let menuIds = [];
          let res = [...this.accessRights];
          for (let i = 0; i < res.length; i++) {
            for (let t = 0; t < res[i].subMenuList.length; t++) {
              for (
                let n = 0;
                n < res[i].subMenuList[t].subMenuList.length;
                n++
              ) {
                if (res[i].subMenuList[t].subMenuList[n].check) {
                  menuIds.push(res[i].subMenuList[t].subMenuList[n].id);
                }
              }
            }
          }
          formData.menuIds = menuIds;
          formData.account = formData.email;
          console.log(formData);
          this.ccRequest
            .do("admin/merchant/user/saveAccount", formData, "POSTJSON")
            .then((res) => {
              this.$emit("success", true);
              this.$message({
                message: this.language("accountManagement.success"),
                type: "success",
              });
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {
          this.$message.error(this.language("accountManagement.validateErr"));
        });
    },
  },
  mounted() {
    this.shopData = this.$shopData;
    if (this.objData && this.objData.id) {
      this.formData = { ...this.objData };
      delete this.formData.password;
      // delete this.formData.password2;
    }
    this.getData();
  },
};
</script>
<style scoped lang="scss">
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
}
.permission {
  margin-top: 40px;
}
.checkbox_wrap {
  display: flex;
  .checkbox_title {
    // min-width: 170px;
    min-width:220px;
  }
}
</style>